export const stateSet = "fromas-state"